import { SVGProps } from 'react';

const SplinePointer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 17A12 12 0 0 1 17 5M5 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4M17 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0m-4.966 7.68a.498.498 0 0 1 .647-.646l9 3.5a.501.501 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z"
    />
  </svg>
);
export default SplinePointer;
